import _ from "lodash";
import { NotificationManager } from 'react-notifications';
import { Types } from "../actions/myActions";



const defaultState = {
  my: {}
};

const myReducers = (state = defaultState, action) => {
  switch (action.type) {
    case Types.MY_CURRENT_AGREEMENT: {

      let newState = _.cloneDeep(state);

      newState.my.currentAgreement = action.agreement;

      return newState;
    }
    case Types.MY_GET_TIMSHEEETS: {

      let newState = _.cloneDeep(state);

      newState.my.myTimesheetsLoading = true;
      // newState.timesheets.modalTimesheet = action.timesheet;

      return newState;
    }
    case Types.MY_UPDATE_TIMSHEEETS: {

      let newState = _.cloneDeep(state);

      console.log('MY_UPDATE_TIMSHEEETS',action)
      newState.my.myTimesheets = action.payload.timesheets;
      newState.my.myTimesheetsLoading = false;
      // newState.timesheets.modalTimesheet = action.timesheet;

      return newState;
    }
    case Types.MY_UPDATE_AGREEMENTS: {

      let newState = _.cloneDeep(state);

      newState.my.myAgreements = action.payload.agreements;
      newState.my.currentAgreement = newState.my.myAgreements && newState.my.myAgreements[0] && newState.my.myAgreements[0].id
      newState.my.currentOrg = action.payload.currentOrg;
      // newState.timesheets.modalTimesheet = action.timesheet;

      return newState;
    }
    case Types.MY_SAVE_CURRENT_TIMESHEET: {

      let newState = _.cloneDeep(state);

      console.log('MY_SAVE_CURRENT_TIMESHEET',action)
      // newState.my.timesheetSaved = true;
      newState.timesheets.modalState = false;
      newState.timesheets.modalTimesheet = null;

      NotificationManager.success(`Your Timesheet has been saved`,'Success')

      return newState;
    }

    default:
      return state;
  }
};

export default myReducers;